import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import ExpandableImageComponent from '../Image/ExpandableImageComponent';

import { avatarPlaceholderSRC } from '../../utils';
import { getFullName } from '../Person/utils';

import StyledLink from '../StyledLink';

const CellPersonWithImage = ({
  person,
  linkUrl,
  isAdminDefault = false,
  isShowImg = true,
  isClickableImage = true,
  personInfo = '',
  personInfoCustomStyle,
  personCustomStyle,
}) => {
  const { photo } = person || {};

  let fullName = getFullName(person);

  if (!fullName && isAdminDefault) {
    fullName = `Carson Admin`;
  }

  return (
    <Box display="flex" alignItems="center">
      {isShowImg && (
        <Box mr="1rem">
          <ExpandableImageComponent
            src={avatarPlaceholderSRC}
            photo={photo}
            caption={fullName}
            isClickable={isClickableImage}
            height="3.2rem"
            isSquare
          />
        </Box>
      )}

      <Box
        display="inline"
        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
        lineHeight={1.1}
      >
        {linkUrl ? (
          <StyledLink to={linkUrl} title={fullName} style={personCustomStyle}>
            {fullName}
          </StyledLink>
        ) : (
          <span title={fullName} style={personCustomStyle}>
            {fullName}
          </span>
        )}
        {personInfo && (
          <span style={personInfoCustomStyle ?? { display: 'block' }}>
            {personInfo}
          </span>
        )}
      </Box>
    </Box>
  );
};

CellPersonWithImage.propTypes = {
  person: PropTypes.instanceOf(Object),
  linkUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isAdminDefault: PropTypes.bool,
  isShowImg: PropTypes.bool,
  isClickableImage: PropTypes.bool,
  personInfo: PropTypes.string,
  personInfoCustomStyle: PropTypes.instanceOf(Object),
  personCustomStyle: PropTypes.instanceOf(Object),
};

export default CellPersonWithImage;
